import * as Sentry from '@sentry/browser';

export function logError(error: Error, msg: string) {
  if (process.env.NODE_ENV !== 'test') {
    console.error(msg, error);
    Sentry.setExtras({ error, msg });
    Sentry.captureException(error);
  }
}
